import type { ReactElement } from 'react';

import { APP_SOURCE_URL, getDashboardLoginUrl, getMarketingUrl } from './constants';
import { Reveal } from './Reveal';

const COLUMNS = [
  {
    title: 'Add-in',
    links: [
      { label: 'Word, Excel, PowerPoint', href: '#hosts' },
      { label: 'How it opens', href: '#how-it-opens' },
      { label: 'Microsoft AppSource', href: APP_SOURCE_URL, external: true },
    ],
  },
  {
    title: 'DocuID',
    links: [
      { label: 'Website', href: 'website' },
      { label: 'Log in', href: 'login' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Support', href: 'support.html' },
      { label: 'Privacy', href: 'privacy-policy.html' },
      { label: 'EULA', href: 'eula.html' },
    ],
  },
] as const;

export function LandingFooter(): ReactElement {
  const loginUrl = getDashboardLoginUrl();
  const marketingUrl = getMarketingUrl();

  return (
    <footer className="mt-4">
      <Reveal>
        <div className="mx-auto max-w-5xl px-5 pt-12 pb-8">
          <div className="grid gap-10 sm:grid-cols-[1.2fr_repeat(3,minmax(0,1fr))]">
            <div>
              <a href="/" className="inline-flex items-center">
                <img
                  src="/assets/logo-transparent-bg.png"
                  alt="DocuID"
                  className="h-6 w-auto dark:brightness-0 dark:invert"
                />
              </a>
              <p className="text-muted-foreground mt-3 max-w-xs text-sm leading-relaxed">
                Open encrypted files in Word, Excel, or PowerPoint. Each host lists only the files
                it can open.
              </p>
            </div>
            {COLUMNS.map((column) => (
              <div key={column.title}>
                <p className="text-foreground text-xs font-semibold tracking-wider uppercase">
                  {column.title}
                </p>
                <ul className="mt-3 space-y-2">
                  {column.links.map((link) => {
                    const href =
                      link.href === 'login'
                        ? loginUrl
                        : link.href === 'website'
                          ? marketingUrl
                          : link.href;
                    const external = 'external' in link && link.external;
                    return (
                      <li key={link.label}>
                        <a
                          href={href}
                          {...(external ? { target: '_blank', rel: 'noreferrer' } : {})}
                          className="text-muted-foreground hover:text-foreground text-sm transition-colors"
                        >
                          {link.label}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
          <p className="text-muted-foreground mt-10 font-mono text-[11px]">
            iVALT DocuID · Word, Excel, and PowerPoint
          </p>
        </div>
      </Reveal>
    </footer>
  );
}
